export default "__VITE_ASSET__QXmx5Bsv__"